import './FormGroupFrame.css';

import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface FormGroupFrameProps {
  caption?: string;
  className?: string;
  children: ReactNode;
}

// Presentational frame of a form group (border + floating caption) — shared
// by the dataset form FormGroup and the layout editor SettingsPanelGroup;
// visibility is the caller's job.
const FormGroupFrame: FC<FormGroupFrameProps> = ({
  caption,
  className,
  children,
}) => (
  <div className={clsx('form-group', className)}>
    {caption && <span className="form-group-label">{caption}</span>}
    {children}
  </div>
);

export default FormGroupFrame;
